<template>
    <div class="w-full h-full mx-auto">
        <div class="fixed left-0 right-0 top-0 mx-auto h-screen" :style="state.backgroundStyle"></div>

        <div class="relative max-w-screen-xl mx-auto">
            <slot name="header"></slot>
            <div class="relative">
               <slot name="content"></slot> 
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, onUpdated } from "vue";

export default {
    name: 'MainPage',
    props: {
        theme: Object,
    },
    setup: function (props) {
        const state = reactive({
            themeColor: [],
            backgroundStyle: {
                backgroundColor : '',
            },
        })

        onUpdated(() => {
            state.themeColor = props.theme
            getBgClass()
        })

        const getBgClass = () => {
            state.backgroundStyle.backgroundColor = state.themeColor.color_2
        }

        return {
            state: state,
            getBgClass
        }
    },
}
</script>

